var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('h1',[_vm._v("ai terra dashboard")]),_c('p',[_vm._v("You should only get here if you're authenticated!")]),(_vm.email)?_c('p',[_vm._v("Your email address: "+_vm._s(_vm.email))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }